import { getformData, getPlatform } from '@/static/js/zjs'
import request from '../static/js/request'
import store from '@/store'
const appid = getPlatform().appid
// 添加错题
export function addMistake(data) {
  return request.post('/mopa/api-internet-user/open/weixin_user_wrongbook/add', [
    {
      appid,
      sourceType: 'mopa',
      questionId: data.questionId,
      openid: data.openId,
      volume: data.volume,
      preferences: data.preference
    }
  ])
}
// 移除错题
export function removeMistake(data) {
  return request.post(
    `/mopa/api-internet-user/open/weixin_user_wrongbook/del-userdata-by-questionid/${appid}/${data.openId}`,
    getformData({
      appid,
      openid: data.openId,
      sourceType: 'mopa',
      questionId: data.questionId
    })
  )
}
// 获取用户错题列表
export function getUserWrongQus(data) {
  return request.get(
    `/mopa/api-internet-user/open/weixin_user_wrongbook/list-by-questionids/${appid}/${data.openid}`,
    {
      params: {
        sourceType: 'mopa',
        questionIds: data.questionIds.join(',')
      }
    }
  )
}

// 喜欢、不喜欢
export function basicbookExplainEnjoy(data) {
  const openid = store.state.user.openid

  return request.post('/mopa/api-answer-card/open/basicbook-explain-enjoy/enjoy', {
    ...data,
    appid,
    openid
  })
}
// 获取用户喜欢/不喜欢列表
export function getEnjoyList(data) {
  const openid = store.state.user.openid

  return request.get(
    `/mopa/api-answer-card/open/basicbook-explain-enjoy/get-enjoy-list/${appid}/${openid}`
  )
}
// 求讲解
export function questionReexplain(data) {
  const openid = store.state.user.openid

  return request.post('/mopa/api-answer-card/open/basicbook-question-reexplain/reexplain', {
    ...data,
    appid,
    openid
  })
}
// 获取用户求过的讲解列表
export function getReexplainList(data) {
  const openid = store.state.user.openid

  return request.get(
    `/mopa/api-answer-card/open/basicbook-question-reexplain/get-reexplain-list/${appid}/${openid}`
  )
}
// 提交纠错
export function addQuestionCorrection(data) {
  const openid = store.state.user.openid

  return request.post(`/mopa/api-answer-card/open/basicbook-question-correction/add`, {
    ...data,
    appid,
    openid
  })
}
// 用户纠错列表
export function getCorrectionList(data) {
  const openid = store.state.user.openid
  return request.get(
    `/mopa/api-answer-card/open/basicbook-question-correction/get-correction-list/${appid}/${openid}`,
    { data }
  )
}
// 用户纠错详情
export function getCorrectionDetail(id) {
  return request.get(
    `/mopa/api-answer-card/open/basicbook-question-correction/get-correction/${id}`
  )
}

// 根据题目查询视频排序列表、播放量、好评量
export function getNumDetail(questionId) {
  return request({
    url: '/mopa/api-answer-card/open/basicbook/question/findVideo',
    method: 'GET',
    params: {
      questionId
    }
  })
}
// 保存看视频记录
export function saveViewExplainRecord(explainId) {
  const openid = store.state.user.openid
  return request({
    url: '/mopa/api-answer-card/open/basicbook/watch/detail/save',
    method: 'POST',
    data: getformData({
      explainId,
      openid,
      appid
    })
  })
}
// 查询匹配的直播间信息
export function matchLivingRoom(params) {
  return request({
    url: '/mopa/api-checking/open/liveroom/match',
    method: 'GET',
    params
  })
}

// 查询匹配的直播间信息
export function getPersionalViewVideoTj(questionIds) {
  const openid = store.state.user.openid

  return request({
    url: '/mopa/api-answer-card/open/basicbook/checkWatchRecord',
    method: 'POST',
    data: {
      appid,
      openid,
      questionIds
    }
  })
}
